import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUnmount } from 'react-use';
import { Modal, Image, Select, Alert, Skeleton, Button } from 'antd';
import { RedoOutlined } from '@ant-design/icons';
import { AppDispatch } from '../../../../../../common/utils/types';
import { formatMilliseconds } from '../../../../../../common/utils/time-lib';
import { getDisplayStoreOptions } from '../../redux/selectors';
import { loadStoresForNewEmployee } from '../../redux/thunks';
import { loadEmployVerification, loadWechatQRCodeURL } from './utils';
import './NewEmployeeModal.less';

const DEFAULT_IMAGE_BASE64 =
  'data:image/png;base64,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';
const APP_TYPE = 'crew';
const TIMEOUT_TIME =
  1000 * 60 * (process.env.NODE_ENV === 'development' ? 10 : 1);
const INTERVAL_TIME = 1000;
const TIME_FORMAT = 'mm:ss';

let countdownIntervalTimer: NodeJS.Timer;
const updateCountdown = (
  targetDate: number,
  countdownIntervalTimer: NodeJS.Timer
) => {
  // get current time
  const currentDate = new Date().getTime();

  // get the difference in time
  const remainingTime = targetDate - currentDate;

  if (remainingTime <= 0) {
    clearInterval(countdownIntervalTimer);

    return 0;
  }

  // convert milliseconds into days, hours, minutes, and seconds
  return remainingTime;
};

const NewEmployeeModal = ({
  visible,
  merchantName,
  onClose,
}: {
  visible: boolean;
  merchantName: string;
  onClose: Function;
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const displayStoreOptions = useSelector(getDisplayStoreOptions);
  const isEmptyStoreList = displayStoreOptions.length <= 0;
  const [selectedStoreId, setSelectedStoreId] = useState(null);
  const [verification, setVerification] = useState('');
  const [newEmployeeQrCode, setNewEmployeeQrCode] = useState('');
  const [loadEmployeeQrCodeError, setLoadEmployeeQrCodeError] = useState(false);
  const [countDown, setCountDown] = useState(TIMEOUT_TIME);
  const [startCountDown, setStartCountDown] = useState(false);
  const getGeneratingParameters = useCallback(async () => {
    loadEmployVerification(merchantName).then(
      ({ data: employeeVerificationData }) => {
        const { verification: employeeVerification } =
          employeeVerificationData || {};

        setVerification(employeeVerification);
      }
    );
  }, [merchantName]);
  const handleEmployeeQrCodeRefresh = () => {
    setCountDown(TIMEOUT_TIME);
    getGeneratingParameters();
  };

  useUnmount(() => {
    clearInterval(countdownIntervalTimer);
    setSelectedStoreId(null);
    setVerification('');
    setNewEmployeeQrCode('');
    setLoadEmployeeQrCodeError(false);
    setCountDown(TIMEOUT_TIME);
  });

  useEffect(() => {
    if (visible) {
      dispatch(loadStoresForNewEmployee()).then(
        ({ payload }: { payload: any }) => {
          const { ids } = payload || {};

          setSelectedStoreId(ids[0]);
        }
      );
      getGeneratingParameters();
    }
  }, [dispatch, getGeneratingParameters, visible]);

  // generate QR code
  useEffect(() => {
    if (merchantName && verification && selectedStoreId) {
      const selectedStoreOriginalData: any = displayStoreOptions.find(
        ({ value }: { value: string }) => selectedStoreId === value
      );

      loadWechatQRCodeURL({
        merchantName,
        employVerification: verification,
        appType: APP_TYPE,
        storeSeqNum: selectedStoreOriginalData?.storeSeqNum || 0,
      })
        .then((url) => {
          setNewEmployeeQrCode(url);
          setStartCountDown(true);
        })
        .catch(() => {
          setLoadEmployeeQrCodeError(true);
        });
    }
  }, [displayStoreOptions, merchantName, selectedStoreId, verification]);

  // count down
  useEffect(() => {
    if (startCountDown) {
      setStartCountDown(false);
      clearInterval(countdownIntervalTimer);
      const targetDate = new Date().getTime() + TIMEOUT_TIME;

      countdownIntervalTimer = setInterval(function () {
        const newCountDonwn = updateCountdown(
          targetDate,
          countdownIntervalTimer
        );

        setCountDown(newCountDonwn);
      }, INTERVAL_TIME);
    }
  }, [startCountDown]);

  return (
    <Modal
      centered
      destroyOnClose
      visible={visible}
      footer={null}
      onCancel={() => {
        onClose();
      }}
    >
      <section className="NewEmployeeModalQRCodeImageModalBody flex flex-column flex-middle">
        {loadEmployeeQrCodeError && (
          <Alert
            message="二维码加载失败！"
            description="请检查您的网络情况，然后关闭窗口重试。"
            type="error"
            showIcon
          />
        )}

        {!newEmployeeQrCode || newEmployeeQrCode === '' ? (
          <Skeleton.Avatar
            active
            className="NewEmployeeModalQRCodeImageSkeleton"
            size="large"
            shape="square"
          />
        ) : (
          <div className="NewEmployeeModalQRCodeImageContainer">
            <Image
              className={`NewEmployeeModalQRCodeImage ${
                countDown === 0 ? 'TimeOut' : ''
              }`}
              src={window.URL.createObjectURL(
                new Blob([newEmployeeQrCode], { type: 'image/jpeg' })
              )}
              fallback={DEFAULT_IMAGE_BASE64}
            />
            {countDown === 0 ? (
              <div className="NewEmployeeModalQRCodeImageCover flex flex-center flex-middle">
                <Button
                  type="text"
                  size="large"
                  className="NewEmployeeModalQRCodeImageRefreshButton flex flex-center flex-middle"
                  onClick={handleEmployeeQrCodeRefresh}
                >
                  <RedoOutlined className="NewEmployeeModalQRCodeImageRefreshIcon flex flex-center flex-middle" />
                </Button>
              </div>
            ) : null}
          </div>
        )}

        <Select
          className="NewEmployeeModalStores"
          placeholder={isEmptyStoreList ? '门店加载请稍等' : '请选择门店'}
          loading={isEmptyStoreList}
          value={selectedStoreId || displayStoreOptions[0]?.value || null}
          options={displayStoreOptions}
          onChange={(storeId) => {
            setSelectedStoreId(storeId);
          }}
        />
        <p className="NewEmployeeModalCountDown">
          {countDown === 0
            ? '二维码失效请点击刷新图标重新生成'
            : `当前二维码有效时间还剩：${formatMilliseconds(
                countDown,
                TIME_FORMAT
              )}`}
        </p>
      </section>
    </Modal>
  );
};

export default NewEmployeeModal;
